// extracted by mini-css-extract-plugin
export var growableInput = "_89-0";
export var tagContainer = "_89-2";
export var textInput = "_89-1";